/**
 * Runs before `./localization/i18n.js` so `lng` matches what we use for API calls.
 *
 * Telegram sends `?lang=` on every open (often the language picked once in the bot). The member
 * may have switched language inside the app; a stale query param must not desync
 * `userSelectedLanguageCode` vs `SessionKey._LANGUAGE`.
 *
 * Prefer an existing stored language (either key); only if nothing is stored, use `?lang=`.
 * Then write both keys to the same value so i18n and settings stay aligned.
 */
import { SessionKey } from "./util/Constant";

try {
	const urlLang = new URLSearchParams(window.location.search).get("lang");
	const sessionLang = localStorage.getItem(SessionKey._LANGUAGE);
	const userPickLang = localStorage.getItem("userSelectedLanguageCode");

	const canonical = sessionLang || userPickLang || urlLang;
	if (canonical) {
		localStorage.setItem(SessionKey._LANGUAGE, canonical);
		localStorage.setItem("userSelectedLanguageCode", canonical);
	}
} catch (err) {
	console.warn("bootstrapLangFromUrl failed:", err);
}
